<template>
  <div
    class="video-card-wrapper wow bounceInRight"
    :class="[videoCardOver, StyleClass.videoCard]"
    @mouseover="onMouseOver"
    @mouseout="onMouseOut"
    @click="onClick"
  >
    <div class="video-card-container">
      <img
        :src="item.snippet.thumbnails.medium.url"
        class="rounded-0 video-card-img"
        alt="video thumbnail"
      />
      <div v-if="isPlaying" class="item-playing">
        <span>{{ $t('page_video.section_videos.en_cours_de_lecture') }}</span>
      </div>
      <div v-else class="contenair_btn_play">
        <img
          :src="isOver ? `${publicPath}over_play.png` : `${publicPath}normal_play.png`"
          width="128"
          class="m-play"
          alt="play icon"
        />
      </div>
      <div class="container-card-title wow zoomInDown" data-wow-duration="1s">
        <h3 class="text-center family-zilla">
          {{ item.snippet.title }}
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
    currentItem: Object
  },
  data () {
    return {
      publicPath: process.env.BASE_URL,
      StyleClass: {
        videoCard: 'video-card'
      },
      isOver: false
    }
  },
  computed: {
    videoCardOver () {
      return this.isOver ? 'video-card-over' : ''
    },
    isPlaying () {
      return this.currentItem && this.item.id === this.currentItem.id
    }
  },
  methods: {
    onMouseOver () {
      this.isOver = true
      this.$emit('mouseOver', this.item)
    },
    onMouseOut () {
      this.isOver = false
      this.$emit('mouseOut', this.item)
    },
    onClick () {
      this.$emit('click', this.item)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/styles/mainStyle.scss";

.video-card-wrapper {
  min-height: 203px;
  height: 100%;
  cursor: pointer;
  transition: all 200ms ease;
  position: relative;

  &.video-card {
    background-color: #49505793 !important;
  }

  &.video-card-over {
    background-color: #495057 !important;

    .item-playing {
      background: #000000ad !important;
    }
  }
}

.video-card-container {
  width: 100%;
  height: 100%;
  position: relative;
  background: transparent;
}

.rounded-0 {
  border-radius: 0;
}

.video-card-img {
  width: 100%;
  height: auto;
}

.container-card-title {
  display: flex;
  margin: auto;
  color: white;
  text-align: center;
  justify-content: center;

  .text-center {
    text-align: center;
    word-wrap: break-word;
  }
}

h3 {
  text-align: center;
  padding: 0px 15px;
  @include family-zilla;
}

.contenair_btn_play {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 71%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.item-playing {
  width: 100%;
  height: 71%;
  position: absolute;
  background: #000000b3;
  z-index: 9999;
  text-align: center;
  align-items: center;
  display: grid;
  transition: all 200ms ease;
  top: 0;
  left: 0;
  color: white !important;

  span {
    font-size: 1.2em;
    @include family-zilla;
  }
}
</style>
